import { dateFunc } from "@/components/Functions/dateFunc";
import {
  getPaymentPrefix,
  havingEditPermission,
  convertToCommaSeparatedNumberwithoutDecimal,
} from "@/utility/common";
import { useTranslation } from "react-i18next";
import { GetCommonDeleteImgButton } from "@/components/Images/CommonImages";
import { formatAmountWithCommas } from "@/utility/common";
import { Link } from "react-router-dom";
import { ActiveTabsOrder } from "@/menuData";
import { DistributionsTab } from "../../Distributions/DistributionsType";
import { setCurrentTab } from "../../Distributions/DistributionsSlice";
import { useDispatch } from "react-redux";
import PaymentStatusColorCode from "../PaymentStatusColorCode";
import { setAccountDetails } from "../../Distributions/Accounts/AccountSetupSlice";
const amountCellRenderers = (params: any) => {
  const amount = params.data.amount;
  const decimalPlace = params.data.decimalPlace;
  const paymentUnitName = params.data.paymentUnitName;
  let formattedAmount = amount;
  if (decimalPlace !== null) {
    formattedAmount = formatAmountWithCommas(amount, decimalPlace);
  } else {
    formattedAmount = convertToCommaSeparatedNumberwithoutDecimal(amount);
  }
  if (paymentUnitName) {
    formattedAmount += ` ${paymentUnitName}`;
  }
  return formattedAmount;
};

export const useGetPaymentStatusColumnDefs = (
  handleCellClick: (params: any) => void,
  handleDeleteEvent: (paymentId: string, paymentReference: string) => void,
  Payment: string[],
  caseId: any,
  documnetId: any
) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return [
    {
      field: "",
      type: "",
      headerName: t("pages.paymentStatus.columnDetails.column11"),
      width: 125,
      sortable: true,
      unSortIcon: true,
      cellRendererParams: {
        selectedDoumnetId: documnetId || "",
      },
      cellRenderer: "downloadCheck",
      cellClass: "align-center",
      headerClass: "align-center",
    },
    {
      checkboxSelection: havingEditPermission(Payment) ? true : false,
      headerCheckboxSelection: havingEditPermission(Payment) ? true : false,
      headerCheckboxSelectionFilteredOnly: havingEditPermission(Payment)
        ? true
        : false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "paymentReference",
      headerName: t("pages.paymentStatus.columnDetails.column1"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      type: "paymentReferenceType",
      cellClass: "text-bold-underline",
      onCellClicked: handleCellClick,
      cellStyle: { cursor: "pointer" },
    },
    {
      field: "payeeName",
      type: "payeeNameType",
      headerName: t("pages.paymentStatus.columnDetails.column2"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      onCellClicked: handleCellClick,
      wordWrap: true,
      autoHeight: true,
    },
    {
      field: "distributionName",
      type: "distributionNameType",
      headerName: t("pages.paymentStatus.columnDetails.column12"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params: any) => {
        return (
          <Link
            to={`/case/${caseId}/distribution/${params.data.distributionId}/?activeTab=0&navigatedFrom=paymentGrid`}
          >
            <span className="text-bold-underline">
              {params.data.distributionName}
            </span>
          </Link>
        );
      },
    },
    {
      field: "accountName",
      type: "accountNameType",
      headerName: t("pages.paymentStatus.columnDetails.column3"),
      sortable: true,
      unSortIcon: true,
      width: 150,
      // onCellClicked: handleCellClick,
      cellRenderer: (params: any) => {
        return (
          <Link
            to={`/case/${caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`}
            onClick={() => {
              dispatch(
                setAccountDetails({
                  accountId: params.data.accountId,
                  subAccountId: "",
                })
              );
              dispatch(setCurrentTab(DistributionsTab.AccountSetUp));
            }}
          >
            <span className="text-bold-underline">
              {params.data.accountName}
            </span>
          </Link>
        );
      },
    },
    {
      field: "subAccountName",
      type: "subAccountNameType",
      headerName: t("pages.paymentStatus.columnDetails.column14"),
      sortable: true,
      unSortIcon: true,
      width: 150,
      // onCellClicked: handleCellClick,
      cellRenderer: (params: any) => {
        return (
          <Link
            to={`/case/${caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`}
            onClick={() => {
              dispatch(
                setAccountDetails({
                  accountId: params.data.accountId,
                  subAccountId: params.data.subAccountId,
                })
              );
              dispatch(setCurrentTab(DistributionsTab.AccountSetUp));
            }}
          >
            <span className="text-bold-underline">
              {params.data.subAccountName}
            </span>
          </Link>
        );
      },
    },
    {
      field: "amount",
      type: "amountType",
      headerName: t("pages.paymentStatus.columnDetails.column4"),
      width: 200,
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
      sortable: true,
      unSortIcon: true,
      onCellClicked: handleCellClick,
      cellRenderer: amountCellRenderers,
    },
    {
      field: "paymentStatus",
      type: "paymentStatusType",

      headerName: t("pages.paymentStatus.columnDetails.column5"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return (
          <>
            <PaymentStatusColorCode paymentStatus={params.data.paymentStatus} />
          </>
        );
      },
      onCellClicked: handleCellClick,
    },
    {
      field: "prefix",
      type: "prefixType",
      headerName: t("pages.paymentStatus.columnDetails.column6"),
      width: 110,
      cellRenderer: function (params: any) {
        return getPaymentPrefix(params.data.prefix);
      },
      sortable: true,
      unSortIcon: true,
      onCellClicked: handleCellClick,
    },
    {
      field: "replacedPaymentReference",
      type: "replacementIdType",
      headerName: t("pages.paymentStatus.columnDetails.column7"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return params.data.replacedPaymentReference ? (
          <Link to={`/case/${caseId}/payment/${params.data?.replacementId}`}>
            <span className="text-bold-underline">
              {params.data.replacedPaymentReference}
            </span>
          </Link>
        ) : (
          "-"
        );
      },
      cellClass: "align-right",
      headerClass: "stepHeaderClass",
    },
    {
      field: "issueDate",
      type: "issueDateType",
      headerName: t("pages.paymentStatus.columnDetails.column8"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return dateFunc(params.data.issueDate).formattedDateOnly;
      },
      onCellClicked: handleCellClick,
    },
    {
      field: "postedDate",
      type: "postedDateType",
      headerName: t("pages.paymentStatus.columnDetails.column9"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return dateFunc(params.data.postedDate).formattedDateOnly;
      },
      onCellClicked: handleCellClick,
    },
    {
      field: "voidedDate",
      type: "voidedDateType",
      headerName: t("pages.paymentStatus.columnDetails.column15"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return dateFunc(params.data.voidedDate).formattedDateOnly;
      },
      onCellClicked: handleCellClick,
    },
    {
      field: "settlementDate",
      type: "settlementDateType",
      headerName: t("pages.paymentStatus.columnDetails.column16"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return dateFunc(params.data?.settlementDate).formattedDateOnly;
      },
      onCellClicked: handleCellClick,
    },
    {
      field: "statusUpdateDate",
      type: "statusUpdateDateType",
      headerName: t("pages.paymentStatus.columnDetails.column10"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return dateFunc(params.data.statusUpdateDate).formattedDateOnly;
      },
      onCellClicked: handleCellClick,
    },
    {
      field: "updatedBy",
      type: "updatedByType",
      headerName: t("pages.paymentStatus.columnDetails.column13"),
      width: 150,
      sortable: true,
      unSortIcon: true,
      onCellClicked: handleCellClick,
    },
    {
      field: "action",
      headerName: "",
      width: 100,
      sortable: false,
      cellRenderer: function (params: any) {
        const style = {
          display: params.data.paymentStatus === 0 ? "block" : "none",
        };
        return (
          <div style={style}>
            <GetCommonDeleteImgButton
              onClick={() => {
                handleDeleteEvent(
                  params.data.paymentId,
                  params.data.paymentReference
                );
              }}
            ></GetCommonDeleteImgButton>
          </div>
          // <div className="motif-row" style={style}>
          //   <div className="motif-col-lg-6">
          //     <CommonTooltipWrapper
          //       tooltipTitle={t("global.globalActions.delete")}
          //     >
          //       <MotifButton
          //         size="small"
          //         variant={DELETE_IMG_VARIANT}
          //         type="button"
          //         onClick={() => {
          //           handleDeleteEvent(
          //             params.data.paymentId,
          //             params.data.paymentReference
          //           );
          //         }}
          //       >
          //         {getCommonDeleteImg()}
          //       </MotifButton>
          //     </CommonTooltipWrapper>
          //   </div>
          // </div>
        );
      },
    },
  ];
};
